import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { calculoFechas, calculoFechasAdd } from "../Portafolio/helpers/calculoFechas";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { useStore } from "../../app/stores/store";
import CodigoInstitucional from "../Modals/CodigoInstitucional";
import { Button, Alert, Row } from 'react-bootstrap';
import LoginForm from "../../features/users/LoginForm";
import Footer from "../Footer";
import { autoPlay } from 'react-swipeable-views-utils';
import SwipeableViews from 'react-swipeable-views';
import { Book, Calendar2Check, Diagram3, ClipboardCheck, Bell, ArrowRightShort } from 'react-bootstrap-icons';
import { SGPersonaFormValues } from "../../app/models/SGPersona";
import "../Portafolio/src/css/detalle_cursos.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "../Portafolio/src/css/fonts.css";
import { AnchorTabsCategories } from "../Portafolio/Handlers/AnchorTabsCategories";
import CodigoInstitucionalPost from '../Modals/CodigoInstutucionalPost';
import { myBreadCrumbs } from '../Portafolio/Handlers/Breadcrumbs';

interface Props { cuota: any; }

export default observer(
  function CursoEdicion({ cuota }: Props) { 

    const { CCTOperacionStore, CATCursosStore, SGPersonaStore, userStore: { isLoggedIn, user }, modalStore } = useStore();
    const { loadCATCursos, getCATCursosRegistryAll } = CATCursosStore;
   // const { createInscription, update_SGPersonas } = InscriptionsStore;
    const { personaDPI } = CCTOperacionStore;
    const {  loadSGPersona } = SGPersonaStore;
    const [SGPersona, setSGPersona] = useState<SGPersonaFormValues>(new SGPersonaFormValues());
    const [showAlert, setShowAlert] = useState(true);
    const [showAlerts, setShowAlerts] = useState(true);
    const { idUser } = useParams<{ idUser: string }>();
    const { id } = useParams<{ id: any }>();
    const AutoPlaySwipeableViews: any = autoPlay(SwipeableViews);
    const [currentSlideIndex, setCurrentSlideIndex] = useState(0);  
    
    interface AlertaValidationProps {
      show: boolean;
      onClose: () => void;
    }    
    interface AlertaProps {
      fechaInscripciones: any;
    }    
    const isMountedRef = useRef(true);

    useEffect(() => {
      return () => {
        // Cuando el componente se desmonta, actualizamos la referencia
        isMountedRef.current = false;
      };
    }, []);
  
    useEffect(() => {
      // Validamos que getCATCursosRegistryAll no sea undefined o null antes de acceder a size
      if (getCATCursosRegistryAll && typeof getCATCursosRegistryAll.size === 'number' && getCATCursosRegistryAll.size <= 1) {
        loadCATCursos();
      }
    
      function buscrPersona(d: string) {
        if (d) {
          personaDPI(d);
        }
      }
    
      // Verificamos que id e idUser sean valores válidos
      if (id && idUser) {
        loadSGPersona(idUser).then(SGPersona => {
          if (isMountedRef.current) {
            setSGPersona(new SGPersonaFormValues(SGPersona));
            if (SGPersona?.dpi) {
              buscrPersona(SGPersona.dpi);
             // console.log("detalles", SGPersona.dpi)
            }
          }
        }).catch(error => {
          console.error("Error cargando SGPersona:", error);
        });
      }
    }, [getCATCursosRegistryAll?.size, loadCATCursos, idUser, loadSGPersona, id]);
    

    if (CATCursosStore.loadingInitial)
      return <LoadingComponent content="Cargando datos.." />;
    return (
      // EMPIEZA PLANTILLA GENERAL -------------------------------------------------------------------------------
      <div>       
       {CATCursosStore.getCATCursoByCodigo.length > 0 ? (
    CATCursosStore.getCATCursoByCodigo.map((postDetail, index) => {
      //console.log("ver datos", postDetail.id)
      const uniqueKey = `${postDetail.id}-${index}`;     
      const actualDate = new Date();
      const startDateFrom = new Date(postDetail.edicion[0]?.fechaDeInicioDuracion);
      const startDateI = new Date(postDetail.edicion[0]?.fechaDeInicioInscripcion);
      const miFecha = startDateI; // tu fecha dinámica
      const endsDateI = new Date(postDetail.edicion[0]?.fechaDeFinalizacionInscripcion);
      const endsDateAdd = calculoFechasAdd(endsDateI);
      const alerdele = postDetail.modalidad
      let validation = postDetail.nivel
      const cursoNivel = postDetail?.nivel;
      let fechaEntreIn : any;
      let fechaEntreFn : any;
      let fechaPropIn : any;
      let fechaPropFn : any;
      const phone = postDetail.phone

     

    if(cursoNivel <=16){

       fechaEntreIn = new Date(postDetail.edicion[0]?.fechaDeInicioDuracion);
       fechaEntreFn = new Date(postDetail.edicion[0]?.fechaDeInicioDuracion);
       fechaPropIn = new Date(postDetail.edicion[0]?.fechaDeInicioDuracion);
       fechaPropFn = new Date(postDetail.edicion[0]?.fechaDeInicioDuracion);

    }else{
            fechaEntreIn = new Date(postDetail.edicion[0].fechasMaestria[0]?.fechaInicio)
            fechaEntreFn = new Date(postDetail.edicion[0].fechasMaestria[0]?.fechaFinal)
            fechaPropIn = new Date(postDetail.edicion[0].fechasMaestria[1]?.fechaInicio)
            fechaPropFn = new Date(postDetail.edicion[0].fechasMaestria[1]?.fechaFinal)
    }  
            
      // Aquí debes definir la variable 'cuota' con el valor adecuado
      // const cuota = ...


      function AlertaInscripcion() {
        return (
          <div className="mensaje_alerta_dcursos">
            <Alert show={showAlert} variant="danger">
              <div className="d-flex justify-content-end">
                <Button onClick={() => setShowAlert(false)} variant="outline-danger"> X </Button>
              </div>
              <Alert.Heading>La inscripción de este servicio ya cerró.</Alert.Heading>
              <hr />
              <p> Por favor si tiene dudas sobre su proceso, comuniquese al Teléfono: <a href="tel:24198120">{phone}</a></p>
            </Alert>
          </div>
        );
      };

      const AlertaValidation: React.FC<AlertaValidationProps> = ({ show, onClose }) => {
        return (
          <div className="mensaje_alerta_dcursos">
            <Alert show={show} variant="info">
              <div className="d-flex justify-content-end">
                <Button onClick={onClose} variant="outline-danger"> X </Button>
              </div>
              <Alert.Heading>Para participar en este curso, se debe contar con la aprobación del Curso y Certificación en Conocimientos de Administración Pública Nivel Básico.</Alert.Heading>
              <hr />
              <p>Si ya cuenta con la certificación puede continuar con su inscripción, de lo contrario comuniquese al teléfono: <a href="tel:24198171">{phone}</a></p>
            </Alert>
          </div>
        );
      };
  
      const AlertaValidation2: React.FC<AlertaValidationProps> = ({ show, onClose }) => {
        return (
          <div className="mensaje_alerta_dcursos">
            <Alert show={show} variant="info">
              <div className="d-flex justify-content-end">
                <Button onClick={onClose} variant="outline-danger"> X </Button>
              </div>
              <Alert.Heading>Para participar en este curso, se debe contar con la aprobación del Curso y Certificación Básica en Conocimientos del Sistema de Administración de Recursos Humanos SARH Y SIARH.</Alert.Heading>
              <hr />
              <p>Si ya cuenta con la certificación puede continuar con su inscripción, de lo contrario comuniquese al teléfono: <a href="tel:24198171">{phone}</a></p>
            </Alert>
          </div>
        );
      };

      function AlertaDelegacion() {
        return (
          <div className="mensaje_alerta_dcursos">
            <Alert show={showAlert} variant="primary">
              <div className="d-flex justify-content-end">
                <Button onClick={() => setShowAlert(false)} variant="outline-primary"> X </Button>
              </div>
              <Alert.Heading>Diplomado exclusivo para la Delegación Peten y Delegación Regional Norte</Alert.Heading>
               <p> Por favor si tiene dudas, comuniquese al Teléfono: <a href="tel:24198181">{phone}</a></p>
            </Alert>
          </div>
        );
      };
  

      const AlertaThenInscripcion: React.FC<AlertaProps> = ({ fechaInscripciones }) => {
        return (
          <div className="mensaje_alerta_dcursos">
            <Alert show={showAlert} variant="primary">
              <div className="d-flex justify-content-end">
                <Button onClick={() => setShowAlert(false)} variant="outline-primary"> X </Button>
              </div>
              <Alert.Heading>
                Las inscripciones estarán habilitadas a partir del <span className="resaltado">{fechaInscripciones}</span>.
              </Alert.Heading>
              <p>¡Esperamos tu participación!</p>
              <hr />
              <p>Por favor, si tiene alguna duda, comuníquese al Teléfono: <a href="tel:24198171">{phone}</a></p>
            </Alert>
          </div>
        );
      };
  
      const cursoGratis = function (obj: any) {
        if (cursoNivel >= 10 && cursoNivel <= 15 && obj === 0) {
          return "Curso Gratis";
        } else {
          return (
            <>
              Q.{" " + cuota}.00
            </>
          );
        }
      };   
  
      const headerCourseBasic = () => {
        if(postDetail.modalidad === "m-Learning"){
          return (          
            <div className="resumen_top col-sm-12 shadow-sm" key={uniqueKey}>
              <div className="row">
                <div className='col-sm-6 col-md-3 resumen_item resumen_item1'><p>Modalidad<span>{postDetail.modalidad}</span></p></div>
                <div className='col-sm-6 col-md-3 resumen_item resumen_item2'><p>Inicio de inscripciones<span>Libre</span></p><br /><p>Último día para inscribirse<span>{calculoFechas(endsDateI)}</span></p></div>
                <div className='col-sm-6 col-md-3 resumen_item resumen_item3'><p>Inicio del curso<span>Inmediato después de su inscripción</span></p></div>
                <div className='col-sm-6 col-md-3 resumen_item resumen_item4'><p>Inversión<span>{cursoGratis(cuota)}</span></p></div>
              </div>            
            </div>          
        )
        }else{
          return (          
            <div className="resumen_top col-sm-12 shadow-sm" key={uniqueKey}>
              <div className="row">
                <div className='col-sm-6 col-md-3 resumen_item resumen_item1'><p>Modalidad<span>{postDetail.modalidad}</span></p></div>
                <div className='col-sm-6 col-md-3 resumen_item resumen_item2'><p>Inicio de inscripciones<span>{calculoFechas(startDateI)}</span></p><br /><p>Cierre de inscripciones<span>{calculoFechas(endsDateI)}</span></p></div>
                <div className='col-sm-6 col-md-3 resumen_item resumen_item3'><p>Inicio del curso<span>{calculoFechas(startDateFrom)}</span></p></div>
                <div className='col-sm-6 col-md-3 resumen_item resumen_item4'><p>Inversión<span>{cursoGratis(cuota)}</span></p></div>
              </div>              
            </div>          
        )
        }       
      };
      const headerCourseDiplo = () => {
        if(postDetail.modalidad === "Presencial"){
          return (           
            <div className="resumen_top col-sm-12 shadow-sm" key={uniqueKey}>
              <div className="row">
                <div className='col-sm-6 col-md-3 resumen_item resumen_item1'><p>Modalidad<span>{postDetail.modalidad}</span></p></div>
                <div className='col-sm-6 col-md-3 resumen_item resumen_item2'><p>Inicio de inscripciones<span>{calculoFechas(startDateI)}</span></p><br /><p>Cierre de inscripciones<span>{calculoFechas(endsDateI)}</span></p></div>
                <div className='col-sm-6 col-md-3 resumen_item resumen_item3'><p>Inicio del curso<span>{calculoFechas(startDateFrom)}</span></p></div>
                <div className='col-sm-6 col-md-3 resumen_item resumen_item4'><p>Inversión<span>Q. 1,200.00</span></p><h3>3 cuotas de Q. 400.00</h3></div>
              </div>              
            </div>            
        )
        }else{
          return (          
            <div className="resumen_top col-sm-12 shadow-sm" key={uniqueKey}>
              <div className="row">
                <div className='col-sm-6 col-md-3 resumen_item resumen_item1'><p>Modalidad<span>{postDetail.modalidad}</span></p></div>
                <div className='col-sm-6 col-md-3 resumen_item resumen_item2'><p>Inicio de inscripciones<span>{calculoFechas(startDateI)}</span></p><br /><p>Cierre de inscripciones<span>{calculoFechas(endsDateI)}</span></p></div>
                <div className='col-sm-6 col-md-3 resumen_item resumen_item3'><p>Inicio del curso<span>{calculoFechas(startDateFrom)}</span></p></div>
                <div className='col-sm-6 col-md-3 resumen_item resumen_item4'><p>Inversión<span>Q. 1,200.00</span></p><h3>4 cuotas de Q. 300.00</h3></div>
              </div>
            </div>          
        )
        }       
      };
      const headerCourseMaes = () => {
        if(postDetail.id === "237"){
        return (          
            <div className="resumen_top col-sm-12 shadow-sm" key={uniqueKey}>
              <div className="row">
                <div className='col-sm-6 col-md-3 resumen_item resumen_item1'><p>Modalidad<span>{postDetail.modalidad}</span></p></div>
                <div className='col-sm-6 col-md-3 resumen_item resumen_item2'><p>Fecha de inicio<span>{calculoFechas(startDateFrom)}</span></p></div>
                <div className='col-sm-6 col-md-3 resumen_item resumen_item3'><p>Cierre de Pre-Inscripciones<span>{calculoFechas(endsDateI)}</span></p></div>
                <div className='col-sm-6 col-md-3 resumen_item_posgrados resumen_item4'>
                  <p>Inversión</p>
                  <div className='posgrados_aranceles'>
                      <p>Inscripción anual <span>Q. 1,031.00</span></p>
                      <p>Cuota trimestral <span>Q. 2,400.00</span></p>
                      <p>ó</p>
                      <p>Pagos mensuales de <span>Q. 800.00</span></p> 
                  </div>
                </div>
              </div>
            </div>          
        )}else{
          return (          
            <div className="resumen_top col-sm-12 shadow-sm" key={uniqueKey}>
              <div className="row">
                <div className='col-sm-6 col-md-3 resumen_item resumen_item1'><p>Modalidad<span>{postDetail.modalidad}</span></p></div>
                <div className='col-sm-6 col-md-3 resumen_item resumen_item2'><p>Inicio de Pre-inscripciones</p>
                    <span>{calculoFechas(startDateI)}</span>
                   </div>
                <div className='col-sm-6 col-md-3 resumen_item resumen_item3'><p>Cierre de Pre-Inscripciones<span>{calculoFechas(endsDateI)}</span></p></div>
                <div className='col-sm-6 col-md-3 resumen_item_posgrados resumen_item4'>
                  <p>Inversión</p>
                  <div className='posgrados_aranceles'>
                      <p>Inscripción anual <span>Q. 1,031.00</span></p>
                      <p>Cuota trimestral <span>Q. 2,400.00</span></p>
                      <p>ó</p>
                      <p>Pagos mensuales de <span>Q. 800.00</span></p> 
                  </div>
                </div>
              </div>
            </div>          
        )}
      };

      const headerCourseDoct = () => {
        return (          
            <div className="resumen_top col-sm-12 shadow-sm" key={uniqueKey}>
              <div className="row">
                <div className='col-sm-6 col-md-3 resumen_item resumen_item1'><p>Modalidad<span>{postDetail.modalidad}</span></p></div>
                <div className='col-sm-6 col-md-3 resumen_item resumen_item2'><p>Inicio de Pre-inscripciones</p>
                    <span>{calculoFechas(startDateI)}</span>
                    </div>
                <div className='col-sm-6 col-md-3 resumen_item resumen_item3'><p>Cierre de Pre-Inscripciones<span>{calculoFechas(endsDateI)}</span></p></div>
                <div className='col-sm-6 col-md-3 resumen_item_posgrados resumen_item4'>
                  <p>Inversión</p>
                  <div className='posgrados_aranceles'>
                      <p>Inscripción anual <span>Q. 1,031.00</span></p>
                      <p>Cuota trimestral <span>Q. 4,500.00</span></p>
                      <p>ó</p>
                      <p>Pagos mensuales de <span>Q. 1,500.00</span></p> 
                  </div>
                </div>
              </div>
            </div>          
        )
      };

      const subHeaderCoursePost = () => {
        return (
        <>
           {postDetail?.id &&
            (String(postDetail.id) === "238" ||
                String(postDetail.id) === "239" ||
                String(postDetail.id) === "240" ||
                String(postDetail.id) === "241") ? (
                null
            ) : (           
              <>
          <div className="row resumen_top_posgrados_row" key={uniqueKey}>
            <div className="resumen_top_posgrados col-sm-12">
              <div className="row">
                <div className="col-sm-6 col-md-3 resumen_item">
                  <div id="inscripcion_ar" className="resumen_status">
                    <p>Pre Inscripciones</p>
                    <span>{calculoFechas(startDateI)}</span>al
                    <br />
                    <span>{calculoFechas(endsDateI)}</span>
                  </div>
                </div>

                <div className="col-sm-6 col-md-3 resumen_item">
                  <div id="entrevistas_ar" className="resumen_status">   
                  <p>Entrevistas</p>                 
                        <span>{calculoFechas(fechaEntreIn)}</span> al <br />
                        <span>{calculoFechas(fechaEntreFn)}</span>
                      
                  </div>
                </div>
                <div className="col-sm-6 col-md-3 resumen_item">
                  <div id="propedeutico_ar" className="resumen_status">
                  <p>Propedeuticos</p>
                        <span>{calculoFechas(fechaPropIn)}</span> al <br />
                        <span>{calculoFechas(fechaPropFn)}</span>                                       
                  </div>
                </div>                
                
                {CCTOperacionStore.dpiByCodigo.map((item) => {
                  const procesos = item.procesos?.[0] || {};
                  const palum = procesos.proceso || null;
                  const pid = procesos.catEdicionesId
                    ? Number(procesos.catEdicionesId)
                    : null;
                  const edid = postDetail.edicion?.[0]?.id
                    ? Number(postDetail.edicion[0].id)
                    : null;

                  // Determina la clase activa según el estado
                  const getActiveClass = () => {
                    if (palum === "Entrevistas" && pid === edid)
                      return "resumen_status_activo_2";
                    if (palum === "Propedeutico" && pid === edid)
                      return "resumen_status_activo_3";
                    if (!palum || pid !== edid)
                      return "resumen_status_activo_1";
                    return "";
                  };

                  if (isLoggedIn === true && pid === edid) {
                    return (
                      <div className="col-sm-6 col-md-3 resumen_item">
                        <p>Estado</p>
                        <span id="resumen_estado_actual">{palum}</span>
                      </div>
                    );
                  } else if (isLoggedIn === true) {
                    return (
                      <div className="col-sm-6 col-md-3 resumen_item">
                        <p>Estado</p>
                        <span>Usted no ha iniciado el proceso</span>
                      </div>
                    );
                  } else {
                    return (
                      <div className="col-sm-6 col-md-3 resumen_item">
                        <p>Estado</p>
                        <span>Debe iniciar sesión</span>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          </div>
          </>
        )}
        </>  
        ) 
};


      const loggedInInscriptionCurso = () => {
        return (
          <Button variant="primary" size="lg" onClick={() => {
            localStorage.setItem("check", "true");
            localStorage.setItem("id_curso", id);
            localStorage.setItem("cuota", cuota);
            localStorage.setItem("bancoCodigo", postDetail.edicion[0].codigoCuenta);
            localStorage.setItem("nombreCurso", postDetail.nombre);
            localStorage.setItem("tipo", "inscripcion");
            modalStore.openModal(
              <CodigoInstitucional
                userId={idUser}
                curso={id}
                tipo={"inscripcion"}
                monto={cuota}
                codigoBanco={postDetail.edicion[0].codigoCuenta}
                nombreCurso={postDetail.nombre}
              />, ["modalInscripcion"]);
          }}
          >Inscríbete Aquí</ Button >
        )
      };
      const loggedOutInscriptionCurso = () => {
        return (
          <Button variant="primary" size="lg" onClick={() => {
            localStorage.setItem("check", "true");
            localStorage.setItem("id_curso", id);
            localStorage.setItem("cuota", cuota);
            localStorage.setItem("bancoCodigo", postDetail.edicion[0].codigoCuenta);
            localStorage.setItem("nombreCurso", postDetail.nombre);
            localStorage.setItem("tipo", "inscripcion");
            modalStore.openModal(
              <LoginForm />, "tiny",
            );
          }}
          >Inscríbete Aquí</ Button >
        )
      };

      const loggedInInscriptionPosgrado = () => {
        return (
          <Button variant="primary" size="lg" onClick={() => {
            localStorage.setItem("check", "true");
            localStorage.setItem("id_curso", id);
            localStorage.setItem("cuota", cuota);
            localStorage.setItem("bancoCodigo", postDetail.edicion[0].codigoCuenta);
            localStorage.setItem("nombreCurso", postDetail.nombre);
            localStorage.setItem("tipo", "preinscripcion");
            modalStore.openModal(
              <CodigoInstitucionalPost
                userId={idUser}
                curso={id}
                tipo={"preinscripcion"}
                monto={cuota}
                codigoBanco={postDetail.edicion[0].codigoCuenta}
                nombreCurso={postDetail.nombre}
              />, ["modalInscripcion"]);
          }}
          >Pre-Inscríbete Aquí</ Button >
        )
      };

      const loggedOutInscriptionPosgrado = () => {
        return (
          <Button variant="primary" size="lg" onClick={() => {
            localStorage.setItem("check", "true");
            localStorage.setItem("id_curso", id);
            localStorage.setItem("cuota", cuota);
            localStorage.setItem("bancoCodigo", postDetail.edicion[0].codigoCuenta);
            localStorage.setItem("nombreCurso", postDetail.nombre);
            localStorage.setItem("tipo", "inscripcion");
            modalStore.openModal(
              <LoginForm />, "tiny"
            );
          }}
          >Pre-Inscríbete Aquí</ Button >
        )
      };

      const checkuserLogPosgrado = function () {
        if (isLoggedIn === true && cursoNivel == 17 || cursoNivel == 18) {
          return (loggedInInscriptionPosgrado());
        }
        else if (isLoggedIn === false && cursoNivel == 17 || cursoNivel == 18) {
          return (loggedOutInscriptionPosgrado())
        }
      };

      const checkuserLogCurso = function () {
        if (isLoggedIn === true) {
          return (loggedInInscriptionCurso());
        }
        else if (isLoggedIn === false) {
          return (loggedOutInscriptionCurso())
        }
      };

      const inscriptLogicCurso = function () {
        if (actualDate > endsDateAdd || actualDate < startDateI) {
          return (< Button disabled size="lg" >Inscríbete Aquí</ Button >)
        }
        else if (actualDate === endsDateI || actualDate <= endsDateAdd) {
          return (checkuserLogCurso())
        }
      };

      const inscriptLogicPosgrado = function () {
        if (actualDate > endsDateAdd || actualDate < startDateI) {
          return (< Button disabled size="lg" >Pre-Inscríbete Aquí</ Button >)
        }
        else if (actualDate === endsDateI || actualDate < endsDateI) {
          return (checkuserLogPosgrado())
        }
      };

      const buttonLogicByLevel = function () {
        if (cursoNivel == 17 || cursoNivel == 18) {
          return (inscriptLogicPosgrado());
        } else {
          return (inscriptLogicCurso())
        }
      };  

      const headerCouseLogic = function (ObjLevel: number) {
        if (ObjLevel == 17 ) {
          return (headerCourseMaes())
        } else if (ObjLevel == 18 ) {
          return (headerCourseDoct())        
        } else if (ObjLevel == 16) {
          return (headerCourseDiplo())        
        } else {
            return (headerCourseBasic())
        }
      }

      const subHeaderCouseLogic = function () {
        if (cursoNivel == 17 || cursoNivel == 18) {
          return (subHeaderCoursePost());
        } else {
        }
      };

      const checkAlert = function () {
        if (actualDate < startDateI) {
          return (< AlertaThenInscripcion fechaInscripciones={calculoFechas(startDateI)} />);
        }
        else if (actualDate > endsDateAdd) {
          return (< AlertaInscripcion />)
        }else if (alerdele === "Presencial") {
          return (< AlertaDelegacion />)
        }
      };
      const data_cursos = CATCursosStore.getCATCursosByCodigoAll.filter((nivel) => {        
        return nivel.modalidad == "m-Learning"        
      });  
      var levelRoot: string = "/";
      var parentCat: number = postDetail?.nivel;
      var childLevel: number = postDetail?.nivel;
      var levelActive: string = postDetail?.nombre;

      const checkValidation = function() {
        if (postDetail.edicion[0]?.codigoCuenta === "11-88-01-25" ||
            postDetail.edicion[0]?.codigoCuenta === "11-89-01-25" ||
            postDetail.edicion[0]?.codigoCuenta === "11-91-01-25" ||
            postDetail.edicion[0]?.codigoCuenta === "11-92-01-25" ||
            postDetail.edicion[0]?.codigoCuenta === "11-93-01-25" 

        ) {
          return (
            <AlertaValidation 
              show={showAlerts}
              onClose={() => setShowAlerts(false)}
            />
          );
        }else if(postDetail.edicion[0]?.codigoCuenta === "11-90-01-25"){
          return (
            <AlertaValidation2 
              show={showAlerts}
              onClose={() => setShowAlerts(false)}
            />
          );
        }
        return null;
      };
      return (

        <div key={uniqueKey}>
          <AnchorTabsCategories />
          <div className="banner_area container-fluid" style={{ backgroundImage: `url(${postDetail.bannerUrl})` }}>
            {/* <img src={postDetail.bannerUrl} alt={postDetail.nombre} /> */}
            <h1>{postDetail.nombre}</h1>
            {/* <div className="banner_top">
              <div className="regional-block-title-curso"></div>
              { {<RegionalSlideCentral />} }
              { {sliderRegional(postDetail.certificacion)} }
            </div> */}
          </div>

          <div>
            {myBreadCrumbs(levelRoot, parentCat, childLevel, levelActive)}
          </div>

          {checkAlert()}         

          <div className="container cursos_area" key={uniqueKey}>
            <div className="row">
                  {headerCouseLogic(postDetail?.nivel)}
                  {checkValidation()}
              <div className="media-show-m">
                {buttonLogicByLevel()}
                <Button variant="outline-primary" size="lg" href={postDetail.iFrame}>Descarga el programa</Button>
              </div>
              <div className="sidebar-info-m sidebar-info">
                <div className='col-sm-12 sidebar_item'><p>Código<span>{postDetail.edicion[0].codigoCuenta}</span></p></div>
                <div className='col-sm-12 sidebar_item'><a href={postDetail.contacto}>Correo de Información<span>{postDetail.contacto}</span></a></div>
                <div className='col-sm-12 sidebar_item'><a href="tel:`${phone}`">Télefono de Contacto<span>{phone}</span></a></div>
              </div>
              <div className="col-sm-12 col-md-9 content-main "  >
                {subHeaderCouseLogic()}
                
                <div className="icontenido_curso" >
                  <Row className="contenido_sect" >
                    <div className="contenido_sect_head">
                      <div className="svg-area">
                        <ClipboardCheck />
                      </div>
                      <h3>¿En qué consiste?</h3>
                      <hr />
                    </div>
                    <p className="curso_objetivos">{postDetail?.objetivos}</p>
                  </Row>             
              <Row className="contenido_sect">
                <div className="contenido_sect_head">
                  <div className="svg-area">
                    <ClipboardCheck />
                  </div>
                  <h3>¿A quién va dirigido?</h3>
                  <hr />
                </div>
                <p className="curso_objetivos">{postDetail?.perfil}</p>
              </Row>

              <Row className="contenido_sect">
                <div className="contenido_sect_head">
                  <div className="svg-area">
                    <Book />
                  </div>
                  <h3>Competencias</h3>
                  <hr />
                </div>
                <p className="curso_objetivos">{postDetail?.competencias}</p>
              </Row>

              <Row className="contenido_sect">
                <div className="contenido_sect_head">
                  <div className="svg-area">
                    <Diagram3 />
                  </div>
                  <h3>Contenido</h3>
                  <hr />
                </div>
                <p className="curso_objetivos">{postDetail?.contenido}</p>
              </Row>

              <Row className="contenido_sect">
                <div className="contenido_sect_head">
                  <div className="svg-area">
                    <Calendar2Check />
                  </div>
                  <h3>Criterios de Evaluación</h3>
                  <hr />
                </div>
                <p className="curso_objetivos">{postDetail.metodologia}</p>
              </Row>
                
                  <div className="cursoedicioncomp" key={uniqueKey}>
                  {data_cursos.length > 0 ? (
                    <AutoPlaySwipeableViews enableMouseEvents >
                      {data_cursos.map((nivel) => {

                        return (
                          <div className='slide_item' key={nivel.id}>
                            <div className="new_curse_badge" >
                              <Bell />
                              <h4>{nivel.modalidad}</h4>
                            </div>

                            <div className="slide_item_content">
                              <h3>{nivel.nombre}</h3>
                              <span><hr /></span>
                              <p>{nivel.objetivos}</p>
                              <a className="slide_button" href={`/app/asesoria/${nivel.id}/${user?.id}`} >
                                <button className="item_sbutton">
                                  <figure className="button_icon">
                                    <span className="button_text">VER CURSO</span>
                                    {<ArrowRightShort />}
                                  </figure>
                                </button>
                              </a>
                            </div>
                          </div>                          
                        )
                      })}
                    </AutoPlaySwipeableViews >
                    ) : (
                      <p>No hay cursos disponibles</p>
                    )}
                  </div>                  
                </div>
              </div>
              <div className="col-sm-12 col-md-3 content-sidebar" >
                <div className='media-show-d'>
                  {buttonLogicByLevel()}
                  <Button variant="outline-primary" href={postDetail?.iFrame} size="lg" target="_blank">Descarga el programa</Button>{' '}
                </div>
                <div className="sidebar-info-d sidebar-info">
                  <div className='col-sm-12 sidebar_item'><p>Código<span>{postDetail.edicion[0].codigoCuenta}</span></p></div>
                  <div className='col-sm-12 sidebar_item'><p>Correo de Información<span>{postDetail.contacto}</span></p></div>
                  <div className='col-sm-12 sidebar_item'><p>Teléfono de Contacto<span>{phone}</span></p></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );  
    })
  ) : (
    <></>
  )}
        <Footer />
      </div>
      // TERMINA PLANTILLA GENERAL -------------------------------------------------------------------------------
    );
  }
);
